(() => {
  if (window.__maybellHomeLoaded) return;
  window.__maybellHomeLoaded = true;

  const closeAllDrawers = () => {
    document.querySelectorAll('.mb-drawer.is-open, .mb-search-drawer.is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.style.overflow = '';
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-mb-open]');
    const closeButton = event.target.closest('[data-mb-close]');

    if (openButton) {
      const target = document.getElementById(openButton.dataset.mbOpen);
      if (!target) return;
      closeAllDrawers();
      target.classList.add('is-open');
      target.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      const focusTarget = target.querySelector('input, button, a');
      window.setTimeout(() => focusTarget?.focus(), 100);
    }

    if (closeButton || event.target.matches('.mb-drawer__backdrop, .mb-search-drawer__backdrop')) {
      closeAllDrawers();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllDrawers();
  });

  const initAnnouncements = (root) => {
    const items = [...root.querySelectorAll('.mb-announcement__item')];
    if (items.length < 2 || root.dataset.autoplay !== 'true') return;
    const interval = Math.max(2000, Number(root.dataset.speed || 4000));
    let index = items.findIndex((item) => item.classList.contains('is-active'));
    index = index < 0 ? 0 : index;
    window.setInterval(() => {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, interval);
  };

  const initHero = (root) => {
    const slides = [...root.querySelectorAll('.mb-hero__slide')];
    const dots = [...root.querySelectorAll('.mb-hero__dot')];
    if (slides.length < 2) return;

    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;
    const speed = Math.max(2500, Number(root.dataset.speed || 5000));
    const autoplay = root.dataset.autoplay === 'true';

    const goTo = (nextIndex) => {
      slides[index].classList.remove('is-active');
      dots[index]?.classList.remove('is-active');
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      dots[index]?.classList.add('is-active');
    };

    const start = () => {
      if (!autoplay) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => goTo(index + 1), speed);
    };

    root.querySelector('[data-mb-hero-prev]')?.addEventListener('click', () => {
      goTo(index - 1);
      start();
    });

    root.querySelector('[data-mb-hero-next]')?.addEventListener('click', () => {
      goTo(index + 1);
      start();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        goTo(dotIndex);
        start();
      });
    });

    root.addEventListener('mouseenter', () => window.clearInterval(timer));
    root.addEventListener('mouseleave', start);
    start();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-mb-announcement]').forEach(initAnnouncements);
    scope.querySelectorAll('[data-mb-hero]').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
